module.exports = __webpack_public_path__ + "static/img/867_phase_function_Paper_PointsHejduk_Prediction.8a3ecd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/867_phase_function_Paper_PointsHejduk_Prediction.png
// module id = HoXI
// module chunks = 0